import {type MouseEvent, useId, useRef} from "react";
import {useMergeRefs} from "@floating-ui/react";
import classNames from "classnames";

import {SearchComboboxSearchIcon} from "../icons/SearchComboboxSearchIcon";
import type {ISearchComboboxMobileFieldProps} from "../types/ISearchComboboxMobileFieldProps";

import * as styles from "./SearchComboboxMobileField.module.css";

const DEFAULT_LABEL = "Miasto, dzielnica lub ulica";

/**
 * Search field of the mobile layer's top bar: 48px pill with the search glyph, the input and a slot for the
 * field controls. The input uses 16px text, below which iOS zooms the page on focus.
 */
export const SearchComboboxMobileField = (props: ISearchComboboxMobileFieldProps) => {
    const {inputProps, inputRef, controls, label = DEFAULT_LABEL, className, dataTestId} = props;

    const fallbackInputId = useId();
    const inputId = inputProps.id ?? fallbackInputId;
    const inputElementRef = useRef<HTMLInputElement | null>(null);
    const mergedInputRef = useMergeRefs([inputElementRef, inputRef]);
    const controlsRef = useRef<HTMLDivElement>(null);

    // A tap on the glyph or the padding focuses the input without blurring it first, so the keyboard does not flicker.
    const onFieldMouseDown = (event: MouseEvent<HTMLDivElement>) => {
        const input = inputElementRef.current;
        const isInsideControls = event.target instanceof Node && Boolean(controlsRef.current?.contains(event.target));

        if (!input || event.target === input || isInsideControls) {
            return;
        }

        event.preventDefault();
        input.focus();
    };

    return (
        <div className={classNames(styles.field, className)} onMouseDown={onFieldMouseDown} data-testid={dataTestId}>
            <SearchComboboxSearchIcon className={styles.searchIcon} />
            <label className={styles.visuallyHidden} htmlFor={inputId}>
                {label}
            </label>
            <input
                type="text"
                enterKeyHint="search"
                autoCapitalize="off"
                autoCorrect="off"
                spellCheck={false}
                {...inputProps}
                id={inputId}
                ref={mergedInputRef}
                className={classNames(styles.input, inputProps.className)}
            />
            {controls ? (
                <div ref={controlsRef} className={styles.controls}>
                    {controls}
                </div>
            ) : null}
        </div>
    );
};
import {type MouseEvent, useId, useRef} from "react";
import {useMergeRefs} from "@floating-ui/react";
import classNames from "classnames";

import {SearchComboboxSearchIcon} from "../icons/SearchComboboxSearchIcon";
import type {ISearchComboboxMobileFieldProps} from "../types/ISearchComboboxMobileFieldProps";

import * as styles from "./SearchComboboxMobileField.module.css";

const DEFAULT_LABEL = "Miasto, dzielnica lub ulica";

/**
 * Search field of the mobile layer's top bar: 48px pill with the search glyph, the input and a slot for the
 * field controls. The input uses 16px text, below which iOS zooms the page on focus.
 */
export const SearchComboboxMobileField = (props: ISearchComboboxMobileFieldProps) => {
    const {inputProps, inputRef, controls, label = DEFAULT_LABEL, className, dataTestId} = props;

    const fallbackInputId = useId();
    const inputId = inputProps.id ?? fallbackInputId;
    const inputElementRef = useRef<HTMLInputElement | null>(null);
    const mergedInputRef = useMergeRefs([inputElementRef, inputRef]);
    const controlsRef = useRef<HTMLDivElement>(null);

    // A tap on the glyph or the padding focuses the input without blurring it first, so the keyboard does not flicker.
    const onFieldMouseDown = (event: MouseEvent<HTMLDivElement>) => {
        const input = inputElementRef.current;
        const isInsideControls = event.target instanceof Node && Boolean(controlsRef.current?.contains(event.target));

        if (!input || event.target === input || isInsideControls) {
            return;
        }

        event.preventDefault();
        input.focus();
    };

    return (
        <div className={classNames(styles.field, className)} onMouseDown={onFieldMouseDown} data-testid={dataTestId}>
            <SearchComboboxSearchIcon className={styles.searchIcon} />
            <label className={styles.visuallyHidden} htmlFor={inputId}>
                {label}
            </label>
            <input
                type="text"
                enterKeyHint="search"
                autoCapitalize="off"
                autoCorrect="off"
                spellCheck={false}
                {...inputProps}
                id={inputId}
                ref={mergedInputRef}
                className={classNames(styles.input, inputProps.className)}
            />
            {controls ? (
                <div ref={controlsRef} className={styles.controls}>
                    {controls}
                </div>
            ) : null}
        </div>
    );
};
